(function ($) { 'use strict';

    $(document).ready(function () {
        
        //subscribe form footer
		$( "#subscribe_submit" ).click(function() {
        	$( "#formSubscribe" ).submit();
		});
        
        // Fix for pre-footer tabs in Bootstrap 5
        // First, ensure all tab panes have the correct classes
        $('#pre-footer .tab-pane, #tab-addr .tab-pane').addClass('fade');
        
        // Initialize the first tab as active
        $('#a-0-tab').addClass('active');
        $('#a-0').addClass('active show');
        $('#b-0').addClass('active show');
        
        // Direct initialization of Bootstrap 5 Tab for the first tab
        if (typeof bootstrap !== 'undefined') {
            const firstTabEl = document.querySelector('#a-0-tab');
            if (firstTabEl) {
                const firstTab = new bootstrap.Tab(firstTabEl);
                // No need to call show() as we've already added the classes
            }
        }
        
        // Handle tab clicks with direct DOM manipulation for maximum compatibility
        $('#pre-footer .nav-link').on('click', function(e) {
            e.preventDefault();
            
            // Get the target tab ID
            const targetId = $(this).attr('href');
            const targetAddressId = targetId.replace('a-', 'b-');
            
            // Remove active class from all tabs and tab panes
            $('#pre-footer .nav-link').removeClass('active');
            $('#pre-footer .tab-pane').removeClass('active show');
            $('#tab-addr .tab-pane').removeClass('active show');
            
            // Add active class to clicked tab and its target panes
            $(this).addClass('active');
            $(targetId).addClass('active show');
            $(targetAddressId).addClass('active show');
            
            // If Bootstrap 5 is available, use its API
            if (typeof bootstrap !== 'undefined') {
                const tab = new bootstrap.Tab(this);
                tab.show();
            }
        });
        
        // Also handle the Bootstrap 5 shown.bs.tab event for completeness
        $('#pre-footer .nav-link').on('shown.bs.tab', function(event) {
            // Get the target tab ID and convert it to the corresponding content tab ID
            const targetId = $(this).attr('href');
            const targetAddressId = targetId.replace('a-', 'b-');
            
            // Ensure the address tab is also active
            $('#tab-addr .tab-pane').removeClass('active show');
            $(targetAddressId).addClass('active show');
        });
        
        // Handle direct anchor links in URL
        if (window.location.hash && window.location.hash.match(/^#a-\d+$/)) {
            const tabId = window.location.hash;
            const addressId = tabId.replace('a-', 'b-');
            
            // Activate the tab
            $('#pre-footer .nav-link').removeClass('active');
            $('#pre-footer .tab-pane').removeClass('active show');
            $('#tab-addr .tab-pane').removeClass('active show');
            
            $(`a[href="${tabId}"]`).addClass('active');
            $(tabId).addClass('active show');
            $(addressId).addClass('active show');
            
            // If Bootstrap 5 is available, use its API
            if (typeof bootstrap !== 'undefined') {
                const tabEl = document.querySelector(`a[href="${tabId}"]`);
                if (tabEl) {
                    const tab = new bootstrap.Tab(tabEl);
                    tab.show();
                }
            }
        }
    });

}(jQuery));